import { render } from "./CaptchaForm.vue?vue&type=template&id=5c4f72e9"
import script from "./CaptchaForm.vue?vue&type=script&lang=js"
export * from "./CaptchaForm.vue?vue&type=script&lang=js"

import "./CaptchaForm.vue?vue&type=style&index=0&id=5c4f72e9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__